import { Typography } from "PFComponents/typography";

import { CustomValueOption, CustomValueSelectProps } from "./custom_value_select";
import { ValueBadge } from "./value_badge";
import css from "./values_list.module.scss";

type ValuesListProps = Pick<
  CustomValueSelectProps,
  | "onChange"
  | "onDateChange"
  | "onClear"
  | "withExpiryDate"
  | "multiple"
  | "placeholder"
  | "disabled"
  | "tabIndex"
> & {
  selectedOptions: CustomValueOption[];
};

export const ValuesList = ({
  selectedOptions,
  onChange,
  onClear,
  onDateChange,
  withExpiryDate,
  multiple,
  placeholder,
  disabled,
  tabIndex
}: ValuesListProps) => {
  if (selectedOptions.length === 0) {
    return placeholder ? (
      <Typography className={css.placeholder} variant="bodyBold">
        {placeholder}
      </Typography>
    ) : null;
  }

  const singleTextValue = !multiple && !withExpiryDate && selectedOptions[0]?.value;

  if (singleTextValue) {
    return (
      <Typography variant="bodyBold" textOverflow="clip" title={singleTextValue}>
        {selectedOptions[0]?.value}
      </Typography>
    );
  }

  return (
    <div className={css.valuesList}>
      {selectedOptions.map((value) => (
        <ValueBadge
          key={value.id}
          value={value}
          locked={value.disabled || disabled}
          onRemove={(selectedOption, event) => {
            event.stopPropagation();
            if (multiple) {
              onChange(selectedOptions.filter(({ id }) => id !== selectedOption.id));
            } else {
              onClear?.();
            }
          }}
          onDateChange={onDateChange}
          withExpiryDate={withExpiryDate}
          tabIndex={tabIndex}
        />
      ))}
    </div>
  );
};
